module.exports = {
  TAG_IDENTIFICATION_TYPE: {
    ENTITY: 'ENTITY',
    PAYMENT: 'PAYMENT',
    SCHEDULE_EVENT: 'SCHEDULE_EVENT'
  }
};
